import { lazy } from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

const 
      InfoPublica = lazy(() => import('../../../views/InfoPublicaAdmin')),
      Solicitudes = lazy(() => import('../../../views/InfoPublicaAdmin/FormularioSolicitud/index'))
      // ,
      // DetalleMicroCapsulas = lazy(() => import('../../../views/Capacitaciones/Microcapsulas/DetalleMicroCapsulas'))


const Index = (props: any) =>{
  return (
    <Switch>
      {/* <Route path={`${props.match.path}/admin/:code`} component={DetalleMicroCapsulas} /> */}
      <Route path={`${props.match.path}/admin`} component={InfoPublica} />
      <Route path={`${props.match.path}/solicitudes`} component={Solicitudes} />
      <Redirect to='/error/404' />
    </Switch>
  )
}

export default Index
